import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/mixin'
import '@/utils/element-ui'
// import '@/assets/css/element-variables.scss'
//监听router
import './routerListening.js'
// 语言
import lang from '@/assets/lang'
Vue.prototype.lang = lang

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
